import { createContext, Dispatch, SetStateAction } from 'react'

import { SvDetails } from '@src/quince-site-common/src/domains/ProductPurchaseInfo'
import { ISwatch } from '@src/quince-site-common/src/domains/Swatch'
import { GiftProductCardStates, SpidProductMap } from '@src/quince-site-common/src/hooks/cart/context/giftProduct.types'

import { LineItemDetails } from '../../../organisms/appLayout/molecules/cartPopUp/cart.helper'
import { Cart } from '../../../services/cartService/cart.service.types'

import useCartContextHelper from './use-cart-context-helper'

interface BaseCartContextState {
  isInitialized: boolean
  isInitializing: boolean
  hasInitError: boolean
  setIsCartPopUpOpen: Dispatch<SetStateAction<boolean>>
  setIsB2BCartPopupOpen: Dispatch<SetStateAction<boolean>>
}

type UseCartContextHelperReturnType = ReturnType<typeof useCartContextHelper>

export type CartContextState =
  | (BaseCartContextState &
      Pick<
        UseCartContextHelperReturnType,
        | 'removeLineItem'
        | 'updateLineItem'
        | 'addToCart'
        | 'addMultipleToCart'
        | 'refreshCheckout'
        | 'buyNowCart'
        | 'getMiniCheckoutForApplePay'
        | 'isBuyNowInProgress'
        | 'updateGiftingFlag'
        | 'updateGiftingDetails'
        | 'moveToSaveForLater'
        | 'moveBackToCart'
        | 'removeAllOutOfStockItems'
        | 'refreshFulfillmentDetails'
        | 'checkInDOBInformationAvailable'
        | 'addBulkOrderCustomizationToCart'
        | 'updateSubscription'
        | 'b2bUpdateCustomizationLineItem'
      > & {
        isInitialized: true
        isActionInProgress: boolean
        errorMessage: string
        setErrorMessage: Dispatch<SetStateAction<string>>
        newCheckout?: Cart
        lineItemDetailsByVariantId: Record<string, LineItemDetails>
        isCartPopUpOpen: boolean
        isB2BCartPopupOpen: boolean
        isGoldBarInCart: boolean
        setIsGoldBarInCart: React.Dispatch<React.SetStateAction<boolean>>
        isLoggedInUserEligbleForGoldBar: boolean
        cartTotalItemsCount: number
        giftCardSpidToSeenState: GiftProductCardStates
        giftCardSpidToDeleteState: GiftProductCardStates
        giftCardSpidToIsPresentInCard: GiftProductCardStates
        updateGiftCardSpidToDelete: (giftSpid: number) => void
        giftCardSpidToProductMap: SpidProductMap
        onSwatchLinkClick: (swatchData: ISwatch[]) => Promise<void>
        swatchData: object | null
        addSwatchesToCart: (id: number[]) => Promise<void>
        removeSwatches: (ids: number[]) => Promise<void>
        setSwatchData: (data: any) => void
        swatchVariantDetailMap: Record<string, SvDetails>
        recentlyAddedLineItemIds?: string[]
      })
  | (BaseCartContextState & {
      isInitialized: false
    })

const CartContext = createContext<CartContextState>({
  isInitialized: false,
  isInitializing: false,
  hasInitError: false,
  setIsCartPopUpOpen: () => undefined,
  setIsB2BCartPopupOpen: () => undefined,
})

// @i18n-ignore
CartContext.displayName = 'CartContext'

export default CartContext
